import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Table, Checkbox, Label, Button } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';

import ConfirmModal from 'components/common/ConfirmModal';
import {
  QUESTION_STATUS_COLOR_MAP,
  QUESTION_STATUS_MAP,
} from 'components/modules/questions/constants';
import { QuestionType } from 'components/modules/questions/types';

import { isQuestionAnswered } from './QuestionTableRow.utils';

const propTypes = {
  question: PropTypes.shape(QuestionType).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

const defaultProps = {};

export default function QuestionTableRow({
  question,
  isSelected,
  onSelect: onSelectProp,
  onEdit: onEditProp,
  onDelete: onDeleteProp,
}) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { id, text, status, answers, groups: questionGroups } = question;
  const isAnswered = isQuestionAnswered(answers);

  function onSelect(e, { checked }) {
    onSelectProp(id, checked);
  }

  function onEdit() {
    onEditProp(question);
  }

  function onConfirmDelete() {
    onDeleteProp(id);
    setShowDeleteModal(false);
  }

  return (
    <Table.Row className={`question-row ${isSelected ? 'selected' : ''}`}>
      <Table.Cell collapsing>
        <Checkbox checked={isSelected} onChange={onSelect} />
      </Table.Cell>
      <Table.Cell>
        <div className="question-text">{text}</div>
      </Table.Cell>
      <Table.Cell>
        <Label color={QUESTION_STATUS_COLOR_MAP[status] || 'grey'}>
          {QUESTION_STATUS_MAP[status] || status}
        </Label>
      </Table.Cell>
      <Table.Cell>
        <Label color={isAnswered ? 'green' : 'red'}>
          {isAnswered ? 'Answered' : 'Not Answered'}
        </Label>
      </Table.Cell>
      <Table.Cell>
        <div className="groups-display">
          {_isEmpty(questionGroups) ? (
            <span className="no-groups">No groups</span>
          ) : (
            questionGroups.map((group) => (
              <Label key={group.id} basic>
                {group.name}
              </Label>
            ))
          )}
        </div>
      </Table.Cell>
      <Table.Cell collapsing>
        <div className="action-buttons">
          <Button
            className="action-button compact"
            icon="edit"
            onClick={onEdit}
            title="Edit question"
          />
          <ConfirmModal
            trigger={
              <Button
                className="delete-red compact"
                icon="trash"
                onClick={() => setShowDeleteModal(true)}
                title="Delete question"
              />
            }
            open={showDeleteModal}
            header="Delete Question"
            content={`Are you sure you want to delete "${text}"? This action cannot be undone.`}
            confirmButton={<Button className="delete-red" content="Delete" />}
            cancelButton={<Button className="action-button-gray" content="Cancel" />}
            onCancel={() => setShowDeleteModal(false)}
            onConfirm={onConfirmDelete}
          />
        </div>
      </Table.Cell>
    </Table.Row>
  );
}

QuestionTableRow.propTypes = propTypes;
QuestionTableRow.defaultProps = defaultProps;
